import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormulaService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrformula`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<any> {
    return this.httpClient.get(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CM4CODIGO', divider: 'Código'  , optional: true, gridColumns: 12 , label: 'Código'},
      {property: 'CM4DESCR' , divider: 'Descrição', optional: true, gridColumns: 12, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CM4CODIGO'  , label: 'Código'},
      {property: 'CM4DESCR'   , label: 'Descrição'},
      {property: 'CM4FORMULA' , label: 'Fórmula'},
    ];
  }

  getFieldFormater(value: any): string {
    return `${value.CM4CODIGO} - ${value.CM4DESCR}`;
  }
}
